import { render, staticRenderFns } from "./relateProduct.vue?vue&type=template&id=745d2f74&scoped=true&"
import script from "./relateProduct.vue?vue&type=script&lang=js&"
export * from "./relateProduct.vue?vue&type=script&lang=js&"
import style0 from "./relateProduct.vue?vue&type=style&index=0&id=745d2f74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745d2f74",
  null
  
)

/* custom blocks */
import block0 from "./relateProduct.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports